import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LTConfirmationDialogComponent } from './components/lt-confirmation-dialog/lt-confirmation-dialog';
import { LTFormErrorComponent } from './components/lt-form-error/lt-form-error.component';
import { LTPageLoadingMessageComponent } from './components/lt-page-loading-message/lt-page-loading-message.component';
import { LTSpinnerComponent } from './components/lt-spinner/lt-spinner.component';
@NgModule({
  imports: [
    CommonModule,
    LTConfirmationDialogComponent,
    LTFormErrorComponent,
    LTPageLoadingMessageComponent,
    LTSpinnerComponent,
  ],
  exports: [
    LTConfirmationDialogComponent,
    LTFormErrorComponent,
    LTPageLoadingMessageComponent,
    LTSpinnerComponent,
  ],
})
export class LTInfoModule { }